import { useState } from "react";
import Modal from "./Modal";

export default function NewFolderDialog({ onClose, onCreate }) {
  const [name, setName] = useState("");

  const submit = (e) => {
    e.preventDefault();
    const trimmed = name.trim();
    if (!trimmed) return;
    onCreate(trimmed);
  };

  return (
    <Modal title="New Folder" onClose={onClose} width="360px">
      <form onSubmit={submit} className="new-folder-form">
        <input
          autoFocus
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Folder name"
        />
        <div className="modal-actions">
          <button type="button" className="fm-btn fm-btn-ghost" onClick={onClose}>
            Cancel
          </button>
          <button type="submit" className="fm-btn" disabled={!name.trim()}>
            Create
          </button>
        </div>
      </form>
    </Modal>
  );
}
